import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { floatControlLabel } from '@project/shared/utils/form-control/js/form-control';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	stateValMsgVisible: "state-field-validation-error--visible",
	stateCountMax: "state-textarea-count-max",
	statePopupVisible: "state-favourite-popup--visible",
	statePopupClose: "state-favourite-popup--close",

	noScrollingBar: "no-scrolling--without-scrollbar",

	popupBox: "js-m-modal-actions",
	textareaContainer: "js-m-modal-actions-textarea-container",
	textareaBox: "js-m-modal-actions__textarea",
	textareaValLength: "js-m-modal-actions__textarea-count-length",
	textareaValLengthMax: "js-m-modal-actions__textarea-count-max",

	confirmationBtn: "js-m-modal-actions-confirmation",

	textcheckboxContainer: "js-m-modal-actions-textcheckbox-container",
	textboxContainer: "js-m-modal-actions-textbox-container",
	textboxGroup: "m-modal-actions__new-list-input",
	textbox: "js-m-modal-actions__newlist",

	checklistContainer: "js-m-modal-actions-checklist-container",
	allChecklistContainer: "js-m-modal-actions-all-checklist-container",

	inputValidationError: "input-validation-error",
	fieldValidationError: "js-checklist-validation-error",
}

const submitApis = {

	addSharedEntry: "addsharedentry"
}

@createModule('FavouritesAction')

export class FavouritesAction extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		resolve();
	}

	rebindCommonViewEvents($popup: JQuery) {

		const _this = this;

		// bind textarea events
		const $textareaContainer = $popup.find(`.${classes.textareaContainer}`);
		if ($textareaContainer.length > 0) {
			_this.bindTextareaContainerEvents($textareaContainer);
		}

		// bind textbox events
		const $textBoxContainer = $popup.find(`.${classes.textboxContainer}`);
		if ($textBoxContainer.length > 0) {
			_this.bindTextboxContainerEvents($textBoxContainer);
		}

		// bind all checkbox validation
		const $allChecklists = $popup.find(`.${classes.allChecklistContainer}`).find("input[type=checkbox]");
		if ($allChecklists.length > 0) {
			this.bindAllCheckboxesEvents($allChecklists);
		}

	}

	bindSubmitEvent($popup: JQuery, contentType: string) {
		// bind submit button
		$popup.find(`.${classes.confirmationBtn}`).on('click', (ev: any) => {

			if (this.canSubmit($popup)) {

				const $btn = $(ev.currentTarget);

				this.lockSubmitBtn($btn);

				this.track("Own Favourites", contentType);

				const url = $popup.data("api-endpoint");
				const id = $popup.data("item-id");

				const textareaValue = $popup.find("textarea").val();
				// get list ids
				const ids = this.getCheckedListIds($popup);

				const textboxValue = this.getTextCheckBoxValue($popup);

				$.ajax({
					type: 'post',
					url: url,
					dataType: 'json',
					data:
					{
						id: id,
						ids: ids,
						textareaInput: textareaValue,
						textInput: textboxValue
					},
					success: (response: any) => {
						if (response.success) {
							window.location.reload();
						}
						else {
							console.log(`submit action-view error, endpoint: ${url}, error type: ${response.error.type}, detail: ${response.error.message}`);
						}
					},
					complete: () => {
						this.unlockSubmitBtn($btn);
					},
					error: (xhr: any, status: string, error: string) => {
						console.log(`submit action-view error, endpoint: ${url}, ${xhr.status}, ${xhr.statusText}, ${error}`);
					}
				});
			}

		});
	}

	bindAddSharedEntrySubmitEvent($popup: JQuery, contentType: string) {
		// bind submit button
		$popup.find(`.${classes.confirmationBtn}`).on('click', (ev: any) => {

			if (this.canSubmit($popup)) {

				const $btn = $(ev.currentTarget);

				this.lockSubmitBtn($btn);

				const url = $popup.data("api-endpoint");
				const SharedEntryIds = $popup.data("item-id");
				// get list ids
				const ids = this.getCheckedListIds($popup);

				const textboxValue = this.getTextCheckBoxValue($popup);

				this.submitTrack(url, contentType);

				$.ajax({
					type: 'post',
					url: url,
					dataType: 'json',
					data:
					{
						SharedEntryIds: SharedEntryIds,
						ids: ids,
						textInput: textboxValue
					},
					success: (response: any) => {
						if (response.success) {
							window.location.assign(response.redirectUrl);
						}
						else {
							console.log(`submit action-view error, endpoint: ${url}, error type: ${response.error.type}, detail: ${response.error.message}`);
						}
					},
					complete: () => {
						this.unlockSubmitBtn($btn);
					},
					error: (xhr: any, status: string, error: string) => {
						console.log(`submit action-view error, endpoint: ${url}, ${xhr.status}, ${xhr.statusText}, ${error}`);
					}
				});
			}

		});
	}

	bindTextareaContainerEvents($textareaContainer: any) {

		const _this = this;

		// bind text area floating label
		$textareaContainer.on("focus", `.${classes.textareaBox}`, (ev: any) => {
			const me = ev.currentTarget;
			floatControlLabel(me, true)
		});

		// bind text area counter
		$textareaContainer.find(`.${classes.textareaBox}`).on("input propertychange", function (ev: any) {
			const $target: any = $(ev.currentTarget);
			_this.countTextarea($target);
			_this.validateInputTextBox($target);
		})
	}

	bindTextboxContainerEvents($textboxContainer: JQuery) {
		const _this = this;

		const $inputBox = $textboxContainer.find(`.${classes.textbox}`);
		const $checkBox = $textboxContainer.parents(`.${classes.textcheckboxContainer}`).find("input[type=checkbox]");

		// bind text box floating label
		$textboxContainer.on("focus", `.${classes.textbox}`, (ev: any) => {
			const me = ev.currentTarget;
			floatControlLabel(me, true)
		});

		// bind textbox validation
		$inputBox.on("input propertychange", function (ev: any) {
			const $target: any = $(ev.currentTarget);

			let value = $target.val();
			if (value.length > 0) {
				$checkBox.prop("checked", true);
			}
			else {
				$checkBox.prop("checked", false);
			}

			if ($checkBox.prop("checked")) {
				_this.validateInputTextBox($target);
			}
			
		})

		// bind textbox checkbox validation
		$checkBox.on("click", function (ev: any) {
			const $target: any = $(ev.currentTarget);
			if (!$target.prop("checked")) {
				$inputBox.removeClass(classes.inputValidationError);
			}
		});
	}

	bindAllCheckboxesEvents($allCheckboxContainer: JQuery) {
		const _this = this;
		const $allCheckboxes = $allCheckboxContainer.find("input[type=checkbox]");
		$allCheckboxes.on("click", function (ev: any) {
			_this.validateCheckList($allCheckboxContainer);

		});
	}

	countTextarea($textarea: any) {
		const $textareaValLength = $textarea.parent().find(`.${classes.textareaValLength}`);
		const $textareaValLengthMax = $textarea.parent().find(`.${classes.textareaValLengthMax}`);
		const textVal = $textarea.val();
		const currentCount = parseInt($textareaValLengthMax.text()) - textVal.length;
		if (currentCount > 0) {
			$textareaValLength.text(currentCount);
			$textareaValLength.parent().removeClass(classes.stateCountMax)
		} else {
			$textareaValLength.text('0');
			$textareaValLength.parent().addClass(classes.stateCountMax)
		};
	}

	getCheckedListIds($currentPopup: JQuery) {

		let $checkedItems = $currentPopup.find(`.${classes.checklistContainer}`).find("input[type='checkbox']:checked");
		const idArr = new Array<string>();
		$checkedItems.each((i: any, e: any) => {
			const value = $(e).attr("id");
			if (typeof (value) != "undefined") {
				idArr.push(value);
			}
		});
		const ids = idArr.join(",");

		return ids;
	}

	getTextCheckBoxValue($popup: JQuery) {
		// get new list name
		let textboxValue = "";
		const newListChecked: boolean = $popup.find(`.${classes.textcheckboxContainer}`).find("input[type='checkbox']").prop("checked");

		if (newListChecked) {
			textboxValue = $popup.find(`.${classes.textboxContainer}`).find(`.${classes.textbox}`).val() as string;
		}

		return textboxValue
	}

	validateInputTextBox($inputBox: any): boolean {

		const value = $inputBox.val();

		if (value == null || value == undefined || value == '' || value.length == 0) {
			$inputBox.addClass(classes.inputValidationError);
			return false;
		} else {
			$inputBox.removeClass(classes.inputValidationError);
			return true;
		}
	}

	// validate all checkboxes, include new created one
	validateCheckList($allCheckboxesContainer: JQuery): boolean {
		let chkVal = false;

		const $chkList = $allCheckboxesContainer.find("input[type=checkbox]");

		$chkList.each((i: any, e: any) => {
			const $ele = $(e);
			if ($ele.prop("checked")) {
				chkVal = true;
			}
		});

		const $popup = $allCheckboxesContainer.parents(`.${classes.popupBox}`);

		const $chkValMsgEle = $popup.find(`.${classes.fieldValidationError}`);
		if (!chkVal) {
			$chkValMsgEle.addClass(classes.stateValMsgVisible);
		} else {
			$chkValMsgEle.removeClass(classes.stateValMsgVisible);
		}

		return chkVal;
	}

	canSubmit($popup: JQuery): boolean {

		// validate textarea
		let textareaVal = true;
		const $textareaContainer = $popup.find(`.${classes.textareaContainer}`);
		if ($textareaContainer.length > 0) {
			const $textarea = $textareaContainer.find(`.${classes.textareaBox}`);
			textareaVal = this.validateInputTextBox($textarea);
		}

		// validate textbox
		let textboxVal = true;
		const $textcheckboxContainer = $popup.find(`.${classes.textcheckboxContainer}`);
		if ($textcheckboxContainer.length > 0) {
			const $textbox = $textcheckboxContainer.find(`.${classes.textbox}`);
			const $textboxChk = $textcheckboxContainer.find("input[type=checkbox]");
			if ($textboxChk.prop("checked")) {
				textboxVal = this.validateInputTextBox($textbox);
			}
		}

		// validate if at leaset one favor list is selected
		let chkVal = true;
		const $allChecklistContainer = $popup.find(`.${classes.allChecklistContainer}`);
		const $allChecklists = $allChecklistContainer.find("input[type=checkbox]");
		if ($allChecklists.length > 0) {
			chkVal = this.validateCheckList($allChecklistContainer);
		}

		if (textareaVal && textboxVal && chkVal) {
			return true;
		} else {
			return false
		}
	}

	displayPopup($popup: JQuery) {
		$popup.addClass(classes.statePopupVisible);
		$('html').addClass(classes.noScrollingBar);

		// bind close button and icon
		$popup.find(`.${classes.statePopupClose}`).on('click', () => {
			this.removePopup($popup);
		});
	}

	removePopup($popup: JQuery) {
		$popup.parent().empty();
		$('html').removeClass(classes.noScrollingBar);
	}

	lockSubmitBtn($btnEle: JQuery) {
		$btnEle.attr("disabled", "disabled");
	}

	unlockSubmitBtn($btnEle: JQuery) {
		$btnEle.removeAttr("disabled");
	}

	submitTrack(submitUrl: string, contentType: string) {
		if (submitUrl.indexOf(submitApis.addSharedEntry) > -1) {
			this.track("Own Favourites", contentType);
		}
	}

	track(action: string, contentType: string) {

		const trackdata: {
			event: string;
			eventCategory: string;
			eventAction: string;
			eventLabel: string;
			eventValue?: string;
		} = {
			event: 'share',
			eventCategory: 'Share Favourites',
			eventAction: action,
			eventLabel: contentType,
		};
		Track.gtmTrack(trackdata);
	}

	stop() { }
}
